export class ComboContratoProjetoPrograma {
	id: number;
	descricao?: string; // usado em combo-pesquisavel
	idContrato?: number;
	idProjeto?: number;
	idPrograma?: number;
	idEmpresa?: number;
	dataInicioVigencia?: Date;
	dataFimVigencia?: Date;
}